export default __webpack_public_path__ + "static/media/market@2x.9425a6c0.svg";